module.exports = __webpack_public_path__ + "static/demolition-house-bbeb3291b63b11f8e8dd55e45be162ac.png";